var twitterFeed = {
	tid: $('#tw-widget').attr('data-twitter-id'),
	module: $('.twitter-module'),

	init: function() {
		//console.log('running twitter feed..');
		if (twitterFeed.module.length > 0) {
			var config = {
				'profile': {"screenName": twitterFeed.tid},
				'domId': 'tw-widget',
				'enableLinks': true,
				'showTime': false,
				'showMore': true
			};
			twitterFetcher.fetch(config);
		}
	}
};